module.exports = __webpack_public_path__ + "img/latitudepay-logo.3ad62dfe.svg";